import { Component, ojs, app } from "modular-openscriptjs";
import { either } from "../../../helpers";

const h = app("h");

export default class FrequentlyOrderedProductView extends Component {
	render(product, ...args) {
		const hasImage = !!product.image;

		// Sophisticated gradient fallback for text-only products
		const renderFallback = () => {
			const initials = product.name
				? product.name.charAt(0).toUpperCase()
				: "?";
			return h.div(
				{
					class: "position-absolute top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center",
					style: "background: linear-gradient(135deg, #6366f1 0%, #a855f7 100%);",
				},
				h.div(
					{
						class: "display-4 fw-bold text-white opacity-25 select-none",
						style: "font-size: 5rem;",
					},
					initials
				)
			);
		};

		return h.div(
			{
				class: "product-card position-relative overflow-hidden rounded-4 border bg-white shadow-sm w-100",
				role: "button",
				style: "aspect-ratio: 3/2;",
			},
			// Product Image or Fallback
			either(
				hasImage,
				h.img({
					src: product.image,
					class: "position-absolute top-0 start-0 w-100 h-100 object-fit-cover",
					alt: product.name,
				}),
				renderFallback()
			),
			// Name Overlay
			h.div(
				{
					class: "position-absolute bottom-0 start-0 w-100 p-2",
				},
				h.div(
					{
						class: "product-name-overlay p-2 px-3 rounded-3 text-dark shadow-sm d-flex align-items-center justify-content-between",
						style: "background: rgba(255, 255, 255, 0.9); backdrop-filter: blur(4px);",
					},
					h.span(
						{
							class: "fw-bold text-wrap fs-xsm pe-2",
							title: product.name,
							style: "display: -webkit-box; -webkit-line-clamp: 2; -webkit-box-orient: vertical; overflow: hidden;",
						},
						product.name
					),
					h.button(
						{
							class: "btn btn-icon rounded-circle shadow-sm d-flex align-items-center justify-content-center flex-shrink-0 text-primary",
							style: "width: 28px; height: 28px;",
							title: "Add to Cart",
						},
						h.i({ class: "bi bi-cart-plus" })
					)
				)
			),
			...args
		);
	}
}

ojs(FrequentlyOrderedProductView);
